export type ReportsTranslations = {
  contents: string;
  dashboardPdf: {
    button: string;
    contents: string;
    description: string;
    hint: string;
    scope: string;
    title: string;
  };
  downloadError: string;
  formats: {
    excel: string;
    pdf: string;
  };
  fullExport: {
    contents: string;
    description: string;
    downloadFailed: string;
    downloading: string;
    generating: string;
    retry: string;
    scope: string;
    start: string;
    startFailed: string;
    stopTracking: string;
    title: string;
  };
  heading: string;
  period: {
    all: string;
    custom: string;
    days30: string;
    days7: string;
    days90: string;
    from: string;
    invalid: string;
    label: string;
    sinceStart: string;
    to: string;
  };
  quizResults: {
    button: string;
    contents: string;
    description: string;
    scope: string;
    title: string;
  };
  subtitle: string;
  summary: {
    candidates: string;
    hint: string;
    quizzesFinished: string;
    recommended: string;
    title: string;
  };
};

export const reportsTranslations: ReportsTranslations = {
  contents: 'Zawartość',
  dashboardPdf: {
    button: 'Drukuj / zapisz PDF',
    contents:
      'Najważniejsze liczby i lejek · mapa województw · napływ kandydatów · wyniki quizu · kompetencje',
    description:
      'Wykresy, mapa i najważniejsze liczby rekrutacji gotowe do wydruku albo zapisania jako PDF i wysłania dalej.',
    hint: 'W oknie drukowania wybierz „Zapisz jako PDF”.',
    scope: 'Dashboard z wybranego okresu',
    title: 'Dashboard do PDF',
  },
  downloadError: 'Wystąpił błąd podczas pobierania raportu. Spróbuj ponownie.',
  formats: {
    excel: 'Excel',
    pdf: 'PDF',
  },
  fullExport: {
    contents: 'Dane z formularza · wynik quizu i status · zgody · osobny arkusz z umiejętnościami',
    description:
      'Wszystko, co wiemy o kandydatach. Duży plik powstaje w tle: możesz zamknąć kartę, a pobierze się sam, gdy wrócisz do panelu.',
    downloadFailed: 'Nie udało się pobrać wygenerowanego pliku. Spróbuj ponownie.',
    downloading: 'Pobieranie wygenerowanego pliku…',
    generating: 'Przygotowujemy plik w tle…',
    retry: 'Spróbuj ponownie',
    scope: 'Kandydaci zarejestrowani w wybranym okresie',
    start: 'Przygotuj Excel',
    startFailed: 'Nie udało się uruchomić eksportu. Spróbuj ponownie.',
    stopTracking: 'Przestań śledzić',
    title: 'Pełny eksport kandydatów',
  },
  heading: 'Raporty',
  period: {
    all: 'Cała rekrutacja',
    custom: 'Własny okres',
    days30: '30 dni',
    days7: '7 dni',
    days90: '90 dni',
    from: 'Od',
    invalid: 'Data początkowa nie może być późniejsza niż końcowa.',
    label: 'Okres raportów',
    sinceStart: 'Od początku rekrutacji',
    to: 'Do',
  },
  quizResults: {
    button: 'Pobierz Excel',
    contents: 'Adres e-mail · punkty · data ukończenia quizu',
    description: 'Lista kandydatów, którzy ukończyli quiz, z liczbą zdobytych punktów.',
    scope: 'Quizy ukończone w wybranym okresie',
    title: 'Wyniki quizu',
  },
  subtitle:
    'Dane rekrutacji do Excela i dashboard gotowy do wydruku: za całą rekrutację albo wybrany okres',
  summary: {
    candidates: 'Zarejestrowani kandydaci',
    hint: 'Kandydaci zarejestrowani w tym okresie, liczeni tak jak na dashboardzie.',
    quizzesFinished: 'Ukończyli quiz',
    recommended: 'Rekomendowani',
    title: 'W wybranym okresie',
  },
};
